import React, { Suspense, useEffect, useState } from "react";
import { lazyWithRetry } from "./LazyWithRetry";
import { Routes, Route } from "react-router-dom";
import ErrorBoundary from "../../base/error-boundary/ErrorBoundary";
import RegisterSuccess from "../../modules/login/RegisterSuccess";
import GlobalLoader from "../globalLoader/GlobalLoader";
import AppStore, { SiteMapItemDI } from "../stores/AppStore";
import { useTranslation } from "react-i18next";
import { routesType } from "./staticRoutes";
import { observer } from "mobx-react";
import ResetPassword from "../../modules/login/ResetPassword";
import ForgotPassword from "../../modules/login/ForgotPassword";
import ForgotPasswordSuccess from "../../modules/login/ForgotPasswordsSuccess";
import ViewLesson from "../../modules/lesson/viewLesson/ViewLesson";
import NewLesson from "../../modules/lesson/newLesson/NewLessonPage";
import EditLesson from "../../modules/lesson/newLesson/EditLessonPage";
import LessonSearchPage from "../../modules/lesson/lessonSearch/LessonSearchPage";
import Header from "../../base/header/Header";
import ProtectedRoute from "../../base/router/ProtectedRoute";
import lessonStore from "../../modules/lesson/lessonStore";



const NotFound = lazyWithRetry(() => import("../not-found/NotFound"));
const Home = lazyWithRetry(() => import("../../modules/home/Home"));
 const Lesson = lazyWithRetry(() => import("../../modules/lesson/LessonRoutes"));
const Login = lazyWithRetry(() => import("../../modules/login/Login"));
const Register = lazyWithRetry(() => import("../../modules/login/Register"));
const Contact = lazyWithRetry(() => import("../../modules/contact/Contact"));
const ContactSuccess = lazyWithRetry(
  () => import("../../modules/contact/Contact-success")
);
const GeneralContent = lazyWithRetry(
  () => import("../../modules/general-content/GeneralContent")
);
const OneTimePassword = lazyWithRetry(
  () => import("../../modules/login/OneTimePassword")
);
const Search = lazyWithRetry(() => import("../../modules/search/SearchPage"));
const CoursewareListPage = lazyWithRetry(
  () => import("../../modules/courseware/pages/CoursewareListPage")
);


const Router: React.FC = (props) => {
  
  useEffect(() => {
  lessonStore.getLists();
}, []);
  const [routes, setRoutes] = useState<any>([]);
  const { t } = useTranslation();

  useEffect(() => {
    const links = AppStore.siteMapList.map((item: SiteMapItemDI) => ({
      type: item.contentType,
      url: item.url,
    }));
    setRoutes(links);
  }, [AppStore.siteMapList]);

  const getComponentUrl: any = (type: string) => {
    let pathName;
    if (routes.length) {
      const componentUrl = routes.find((route: any) => route.type === type);
      AppStore.setLessonsRoute(componentUrl?.url);
      pathName = componentUrl?.url;
    }
    return pathName || "/not-found";
  };
 const hideHeaderPaths = [
    "/login",
    "/register",
    "/register-success",
    "/forgot-password",
    "/forgot-password-success",
    "/reset-password"
  ];
  return (
    <ErrorBoundary>
      {!hideHeaderPaths.includes(location.pathname) && <Header />}
   <Suspense fallback={<GlobalLoader showAnyway={true} />}>
        <Routes>
          <Route
            path="/one-time-password/:authType"
            element={<OneTimePassword />}
          />
          <Route
            path={getComponentUrl(routesType.contactUs)}
            element={<Contact />}
          />
          <Route path="/contact-success" element={<ContactSuccess />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register-success" element={<RegisterSuccess />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/forgot-password-success"
            element={<ForgotPasswordSuccess />}
          />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Home />} />
          <Route path="/courseware" element={<CoursewareListPage />} />
           {/* <Route path={`${getComponentUrl(routesType.lessons)}*`} element={<Lesson />} />  */}
          <Route path={`/${t("Search-path")}`} element={<Search />} />
        <Route element={<ProtectedRoute />}>
          <Route
            path={`${getComponentUrl(routesType.lessons)}/`}
            element={<LessonSearchPage />}
          />
          <Route
            path={`${getComponentUrl(routesType.lessons)}${t(
              "Lesson-new-path"
            )}`}
            element={<NewLesson />}
          />

          <Route
            path={`${getComponentUrl(routesType.lessons)}${t(
              "Lesson-edit-path"
            )}/:lessonUrl/`}
            element={<EditLesson />}
          />
          <Route
            path={`${getComponentUrl(routesType.lessons)}:lessonUrl`}
            element={<ViewLesson />}
          />
          </Route>
          <Route path="*" element={<GeneralContent />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
};

export default observer(Router);
